// frontend/src/utils/leagueUtils.js

export const LEAGUE_INFO = {
  // Top Leagues
  "EPL": { name: "England Premier League", flag: "🏴󠁧󠁢󠁥󠁮󠁧󠁿", short: "EPL" },
  "SPAIN_LA_LIGA": { name: "Spain La Liga", flag: "🇪🇸", short: "La Liga" },
  "GERMANY_BUNDESLIGA": { name: "Germany Bundesliga", flag: "🇩🇪", short: "Bundesliga" },
  "ITALY_SERIE_A": { name: "Italy Serie A", flag: "🇮🇹", short: "Serie A" },
  "FRANCE_LIGUE_1": { name: "France Ligue 1", flag: "🇫🇷", short: "Ligue 1" },
  "UCL": { name: "UEFA Champions League", flag: "🇪🇺", short: "UCL" },
  "UCL_QUALIFICATION": { name: "UCL Qualifiers", flag: "🇪🇺", short: "UCL Q" },
  "UEL": { name: "UEFA Europa League", flag: "🇪🇺", short: "UEL" },
  
  // Aliases
  "ENGLAND_PREMIER_LEAGUE": { name: "England Premier League", flag: "🏴󠁧󠁢󠁥󠁮󠁧󠁿", short: "EPL" },
  "FRANCE_LIGUE_ONE": { name: "France Ligue 1", flag: "🇫🇷", short: "Ligue 1" },
  "UEFA_CHAMPS_LEAGUE": { name: "UEFA Champions League", flag: "🇪🇺", short: "UCL" },
  "UEFA_EUROPA_LEAGUE": { name: "UEFA Europa League", flag: "🇪🇺", short: "UEL" },

  // Other Leagues
  "UEFA_SUPER_CUP": { name: "UEFA Super Cup", flag: "🇪🇺", short: "Super Cup" },
  "FIFA_CLUB_WORLD_CUP": { name: "FIFA Club World Cup", flag: "🌍", short: "Club WC" },
  "FIFA_WORLD_CUP": { name: "FIFA World Cup 2026", flag: "🏆", short: "WC26" },
  "WORLD_CUP_2026": { name: "FIFA World Cup 2026", flag: "🏆", short: "WC26" },
  "FIFA_WC_2026": { name: "FIFA World Cup 2026", flag: "🏆", short: "WC26" },
  "FIFA_WORLD_CUP_QUALIFIERS_EUROPE": { name: "FIFA World Cup Qualifiers Europe", flag: "🌍", short: "WC Q EU" },
  "UEFA_NATIONS_LEAGUE": { name: "UEFA Nations League", flag: "🌍", short: "UEFA NL" },
  "NETHERLANDS_EREDIVISIE": { name: "Netherlands Eredivisie", flag: "🇳🇱", short: "Eredivisie" },
  "ENGLAND_EFL_CHAMPIONSHIP": { name: "England EFL Championship", flag: "🇬🇧", short: "Championship" },
  "EFL_CHAMP": { name: "England EFL Championship", flag: "🇬🇧", short: "Championship" },
  "ENGLAND_FA_CUP": { name: "England FA Cup", flag: "🇬🇧", short: "FA Cup" },
  "PORTUGAL_PRIMEIRA_LIGA": { name: "Portugal Primeira Liga", flag: "🇵🇹", short: "Primeira Liga" },
  "BELGIUM_FIRST_DIVISION_A": { name: "Belgium First Division A", flag: "🇧🇪", short: "Pro League" },
  "SCOTLAND_PREMIERSHIP": { name: "Scotland Premiership", flag: "🏴󠁧󠁢󠁳󠁣󠁴󠁿", short: "Premiership" },
  "LEAGUE_OF_IRELAND": { name: "League of Ireland", flag: "🇮🇪", short: "LOI" },
  "POLAND_EKSTRAKLASA": { name: "Poland Ekstraklasa", flag: "🇵🇱", short: "Ekstraklasa" },
  "CROATIA_HNL": { name: "Croatia HNL", flag: "🇭🇷", short: "HNL" },
  "DENMARK_SUPERLIGA": { name: "Denmark Superliga", flag: "🇩🇰", short: "Superliga" },
  "SWEDEN_ALLSVENSKAN": { name: "Sweden Allsvenskan", flag: "🇸🇪", short: "Allsvenskan" },
  "TURKEY_SUPER_LIG": { name: "Turkey Super Lig", flag: "🇹🇷", short: "Super Lig" },
  "AUSTRIA_BUNDESLIGA": { name: "Austria Bundesliga", flag: "🇦🇹", short: "AUT Bundesliga" },
  "SWITZERLAND_SUPER_LEAGUE": { name: "Switzerland Super League", flag: "🇨🇭", short: "SUI Super League" },
  "RUSSIA_PREMIER_LEAGUE": { name: "Russia Premier League", flag: "🇷🇺", short: "RPL" },
  "NORWAY_ELITESERIEN": { name: "Norway Eliteserien", flag: "🇳🇴", short: "Eliteserien" },
  "CYPRUS_FIRST_DIVISION": { name: "Cyprus First Division", flag: "🇨🇾", short: "CYP 1st Division" },
  "CZECH_FIRST_LEAGUE": { name: "Czech First League", flag: "🇨🇿", short: "CZE 1. Liga" },
  "HUNGARY_NB_I": { name: "Hungary NB I", flag: "🇭🇺", short: "NB I" },
  "GREECE_SUPER_LEAGUE": { name: "Greece Super League", flag: "🇬🇷", short: "GRE Super League" },
  "ROMANIA_LIGA_I": { name: "Romania Liga I", flag: "🇷🇴", short: "Liga I" },
  "SLOVAKIA_1_LIGA": { name: "Slovakia 1. Liga", flag: "🇸🇰", short: "SVK 1. Liga" },
  "SLOVENIA_PRVA_LIGA": { name: "Slovenia Prva Liga", flag: "🇸🇮", short: "Prva Liga" },
  "BULGARIA_FIRST_LEAGUE": { name: "Bulgaria First League", flag: "🇧🇬", short: "BUL First League" },
  "SERBIA_SUPER_LIGA": { name: "Serbia Super Liga", flag: "🇷🇸", short: "SRB Super Liga" },
  "BOSNIA_PREMIER_LEAGUE": { name: "Bosnia Premier League", flag: "🇧🇦", short: "BIH Premier League" },
  "FINLAND_VEIKKAUSLIIGA": { name: "Finland Veikkausliiga", flag: "🇫🇮", short: "Veikkausliiga" },
  "GEORGIA_EROVNULI_LIGA": { name: "Georgia Erovnuli Liga", flag: "🇬🇪", short: "Erovnuli Liga" },
  "LATVIA_VIRSLIGA": { name: "Latvia Virsliga", flag: "🇱🇻", short: "Virsliga" },
  "UEFA_CONFERENCE_LEAGUE": { name: "UEFA Conference League", flag: "🇪🇺", short: "UECL" },
  "ARGENTINA_LIGA_PROFESIONAL": { name: "Argentina Liga Profesional", flag: "🇦🇷", short: "Liga Profesional" },
  "BRAZIL_SERIE_A": { name: "Brazil Serie A", flag: "🇧🇷", short: "BRA Serie A" }
};

/** ISO 3166-1 alpha-2 for react-country-flag; null = emoji fallback */
export const LEAGUE_COUNTRY_CODES = {
  EPL: 'GB',
  ENGLAND_PREMIER_LEAGUE: 'GB',
  ENGLAND_EFL_CHAMPIONSHIP: 'GB',
  EFL_CHAMP: 'GB',
  ENGLAND_FA_CUP: 'GB',
  SPAIN_LA_LIGA: 'ES',
  GERMANY_BUNDESLIGA: 'DE',
  ITALY_SERIE_A: 'IT',
  FRANCE_LIGUE_1: 'FR',
  FRANCE_LIGUE_ONE: 'FR',
  NETHERLANDS_EREDIVISIE: 'NL',
  PORTUGAL_PRIMEIRA_LIGA: 'PT',
  BELGIUM_FIRST_DIVISION_A: 'BE',
  SCOTLAND_PREMIERSHIP: 'GB',
  LEAGUE_OF_IRELAND: 'IE',
  POLAND_EKSTRAKLASA: 'PL',
  CROATIA_HNL: 'HR',
  DENMARK_SUPERLIGA: 'DK',
  SWEDEN_ALLSVENSKAN: 'SE',
  TURKEY_SUPER_LIG: 'TR',
  AUSTRIA_BUNDESLIGA: 'AT',
  SWITZERLAND_SUPER_LEAGUE: 'CH',
  RUSSIA_PREMIER_LEAGUE: 'RU',
  NORWAY_ELITESERIEN: 'NO',
  CYPRUS_FIRST_DIVISION: 'CY',
  CZECH_FIRST_LEAGUE: 'CZ',
  HUNGARY_NB_I: 'HU',
  GREECE_SUPER_LEAGUE: 'GR',
  ROMANIA_LIGA_I: 'RO',
  SLOVAKIA_1_LIGA: 'SK',
  SLOVENIA_PRVA_LIGA: 'SI',
  BULGARIA_FIRST_LEAGUE: 'BG',
  SERBIA_SUPER_LIGA: 'RS',
  BOSNIA_PREMIER_LEAGUE: 'BA',
  FINLAND_VEIKKAUSLIIGA: 'FI',
  GEORGIA_EROVNULI_LIGA: 'GE',
  LATVIA_VIRSLIGA: 'LV',
  ARGENTINA_LIGA_PROFESIONAL: 'AR',
  BRAZIL_SERIE_A: 'BR',
  UCL: 'EU',
  UCL_QUALIFICATION: 'EU',
  UEL: 'EU',
  UEFA_CHAMPS_LEAGUE: 'EU',
  UEFA_EUROPA_LEAGUE: 'EU',
  UEFA_SUPER_CUP: 'EU',
  UEFA_CONFERENCE_LEAGUE: 'EU',
};

/**
 * Spotlight tier for "top match of the day" toast (higher = more prominent competition).
 * Keys align with API/DB `league` and with LEAGUE_INFO.
 */
const INTERNATIONAL_LEAGUE_IDS = new Set([
  'FIFA_WORLD_CUP',
  'WORLD_CUP_2026',
  'FIFA_WC_2026',
  'FIFA_WORLD_CUP_QUALIFIERS_EUROPE',
  'UEFA_NATIONS_LEAGUE',
]);

export const isInternationalLeague = (leagueId) =>
  Boolean(leagueId && INTERNATIONAL_LEAGUE_IDS.has(leagueId));

const LEAGUE_SPOTLIGHT_WEIGHT = {
  UEFA_CHAMPS_LEAGUE: 100,
  UCL: 100,
  UCL_QUALIFICATION: 90,
  FIFA_WORLD_CUP: 100,
  WORLD_CUP_2026: 100,
  FIFA_WC_2026: 100,
  FIFA_CLUB_WORLD_CUP: 95,
  UEFA_SUPER_CUP: 92,
  UEFA_NATIONS_LEAGUE: 88,
  FIFA_WORLD_CUP_QUALIFIERS_EUROPE: 85,
  EPL: 78,
  ENGLAND_PREMIER_LEAGUE: 78,
  SPAIN_LA_LIGA: 78,
  GERMANY_BUNDESLIGA: 78,
  ITALY_SERIE_A: 78,
  FRANCE_LIGUE_1: 78,
  FRANCE_LIGUE_ONE: 78,
  UEL: 58,
  UEFA_EUROPA_LEAGUE: 58,
  UEFA_CONFERENCE_LEAGUE: 52,
  NETHERLANDS_EREDIVISIE: 42,
  PORTUGAL_PRIMEIRA_LIGA: 42,
  SCOTLAND_PREMIERSHIP: 40,
  TURKEY_SUPER_LIG: 38,
  BELGIUM_FIRST_DIVISION_A: 36,
  AUSTRIA_BUNDESLIGA: 32,
  SWITZERLAND_SUPER_LEAGUE: 32,
  GREECE_SUPER_LEAGUE: 30,
  ENGLAND_EFL_CHAMPIONSHIP: 28,
  EFL_CHAMP: 28,
  ENGLAND_FA_CUP: 26,
  ARGENTINA_LIGA_PROFESIONAL: 25,
  BRAZIL_SERIE_A: 25
};

const LEAGUE_SPOTLIGHT_FALLBACK_KNOWN = 12;

/**
 * @param {string | undefined} leagueId
 * @returns {number}
 */
export const getLeagueSpotlightWeight = (leagueId) => {
  if (!leagueId || typeof leagueId !== 'string') return 0;
  if (Object.prototype.hasOwnProperty.call(LEAGUE_SPOTLIGHT_WEIGHT, leagueId)) {
    return LEAGUE_SPOTLIGHT_WEIGHT[leagueId];
  }
  if (LEAGUE_INFO[leagueId]) {
    return LEAGUE_SPOTLIGHT_FALLBACK_KNOWN;
  }
  if (process.env.NODE_ENV === 'development') {
    console.warn('[getLeagueSpotlightWeight] Unknown league id (not in LEAGUE_INFO):', leagueId);
  }
  return 0;
};

export const getLeagueFullName = (leagueId) => LEAGUE_INFO[leagueId]?.name || leagueId.replace(/_/g, ' ');
export const getLeagueFlag = (leagueId) => LEAGUE_INFO[leagueId]?.flag || '🏳️';

export const getLeagueCountryCode = (leagueId) =>
  LEAGUE_COUNTRY_CODES[leagueId] ?? null;

/**
 * Tier-2 leagues: clubs without a known logo show a country flag instead of DefaultShield.
 * code — ISO 3166-1 alpha-2 for react-country-flag; image — slug in public/teams
 * for subdivisions react-country-flag can't render (e.g. Scotland has no alpha-2 code).
 */
const LEAGUE_FLAG_FALLBACK = {
  ENGLAND_FA_CUP: { code: 'GB' },
  EFL_CHAMP: { code: 'GB' },
  ENGLAND_EFL_CHAMPIONSHIP: { code: 'GB' },
  BELGIUM_FIRST_DIVISION_A: { code: 'BE' },
  SCOTLAND_PREMIERSHIP: { image: 'Scotland' },
  LEAGUE_OF_IRELAND: { code: 'IE' },
};

export const getLeagueFlagFallback = (leagueId) =>
  (leagueId && LEAGUE_FLAG_FALLBACK[leagueId]) || null;

export const getLeagueShortLabel = (leagueId) =>
  LEAGUE_INFO[leagueId]?.short || leagueId.replace(/_/g, ' ');

export const getLeagueAbbreviation = (leagueId) => {
    const info = LEAGUE_INFO[leagueId];
    return info ? `${info.flag} ${info.short}` : leagueId;
}; 